<template>
    <div class="xeBar heightMAX rounded" style="overflow: hidden">
        <div class="heightMAX" style="padding: 0">
            <drop @dragover="handleBodyDragOver(...arguments)" @drop="handleBodyDrop(...arguments)"
                class="heightMAX kbet-custom-reset">
                <div class="rounded kbet-widget-energy heightMAX" style="display: block">
                    <div class="d-flex justify-content-between align-items-center">
                        <div class="title mb-0 d-flex justify-content-between align-items-center w-100">
                            {{ $t(widget.title) }}
                            <div v-if="isStacked" class="d-flex align-items-center">
                                <div class="safari-style-buttons">
                                    <label class="safari-button red">
                                        <input type="radio" value="abs" v-model="isNormalized"
                                            @change="onNormalizeToggle" />
                                        <span class="button-dot"></span>
                                    </label>
                                    <label class="safari-button yellow">
                                        <input type="radio" value="per" v-model="isNormalized"
                                            @change="onNormalizeToggle" />
                                        <span class="button-dot"></span>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="chartHeightMax">
                        <div class="h-100 p-5">
                            <div v-show="viewMode === 'Chart'" ref="barChart" style="width: 100%; height: 100%"
                                class="barChart"></div>
                        </div>
                    </div>
                </div>
            </drop>
        </div>

        <b-modal ref="modalSetting" size="lg" :title="`${$t('설정')} - Bar ${$t('차트')}`" bodyClass="p-t-0 p-b-0"
            hide-footer>
            <chart-bar-setting :initSetting="chartSetting" @on-modal-cancel="onModalCancel" @on-modal-ok="onModalOK" />
        </b-modal>
    </div>
</template>

<script>
import xeBaseWidget from "@src/views/widget/v1/common/xeBaseWidget.js";
import * as echarts from "echarts";
import chartBarSetting from "./setting/xeBarSetting.vue";
import utils from "@src/views/widget/v1/common/xeBaseUtils.js";
import moment from "moment";

export default {
    name: "xeBar",
    extends: xeBaseWidget,
    components: {
        chartBarSetting,
    },
    props: ["cardHeight", "cardWidth"],
    data() {
        return {
            chart: null,
            themeColor: global.xe.parseBool(localStorage.contentInverse)
                ? require("../../../components/vue-chartjs/Sample/ChartOptions/DashboardChartColor.json").dark
                : require("../../../components/vue-chartjs/Sample/ChartOptions/DashboardChartColor.json").light,
            viewMode: "Chart",
            isNormalized: "abs", // 정규화 토글 상태: "abs" (일반), "per" (비중)
            originalDatasets: [], // 원본 데이터셋 저장
            filterdPoint: new Set(),
            widgetLogs: null,
            resizeObserver: null,
        };
    },
    computed: {
        cardSize() {
            return this.cardWidth * this.cardHeight;
        },
        chartSetting() {
            return JSON.parse(JSON.stringify(this.widget));
        },
        master() {
            return this.$store.getters.master;
        },
        // 스택 여부 확인
        isStacked() {
            return this.widget.chart.options && this.widget.chart.options.stacked;
        },
        // 주차 집계 여부 확인
        isWeekAggregation() {
            return this.widget.aggregationType === true;
        },
    },
    watch: {
        cardSize: {
            handler(newSize, oldSize) {
                if (newSize !== oldSize && this.chart) {
                    this.chart.resize();
                }
            },
        },
        isNormalized() {
            this.updateChartData();
        },
    },
    created() {
        this.initializeWidgetDefaults();
    },
    mounted() {
        this.$nextTick(() => {
            this.initChart();
            // 메서드 참조로 등록
            window.addEventListener("resize", this.handleResize);

            // ResizeObserver를 사용하여 차트 컨테이너 크기 변화 감지
            this.setupResizeObserver();
        });
    },
    beforeDestroy() {
        this.disposeChart();
        // 동일한 메서드 참조로 제거
        window.removeEventListener("resize", this.handleResize);

        // ResizeObserver 정리
        if (this.resizeObserver) {
            this.resizeObserver.disconnect();
            this.resizeObserver = null;
        }
    },
    methods: {
        // 초기화 메서드들
        initializeWidgetDefaults() {
            if (!this.widget.addition) {
                this.widget.addition = {
                    afterAction: "",
                    fixed: 0,
                };
            }
            if (!this.widget.self) {
                this.widget.self = {
                    baseline: { type: this.searchBoxCond.type, sTi: "", eTi: "" },
                    compare: { type: this.searchBoxCond.type, sTi: "", eTi: "" },
                };
            }

            // chart 기본 구조 초기화
            if (!this.widget.chart) {
                this.widget.chart = {};
            }

            // chart 기본 속성
            if (!this.widget.chart.chartFontSize) {
                this.widget.chart.chartFontSize = 12;
            }
            if (!this.widget.chart.series) {
                this.widget.chart.series = [];
            }

            // options 구조 초기화
            if (!this.widget.chart.options) {
                this.widget.chart.options = {};
            }

            // legend 구조 초기화
            if (!this.widget.chart.options.legend) {
                this.widget.chart.options.legend = {
                    display: true,
                    labels: {
                        fontSize: 12,
                        fontColor: "#000000"
                    }
                };
            }
            if (!this.widget.chart.options.legend.labels) {
                this.widget.chart.options.legend.labels = {
                    fontSize: 12,
                    fontColor: "#000000"
                };
            }

            // yAxes 구조 초기화
            if (!this.widget.chart.options.yAxes) {
                this.widget.chart.options.yAxes = {
                    left: {
                        display: true,
                        label: "",
                        unit: "",
                        fontSize: 12
                    }
                };
            }
            if (!this.widget.chart.options.yAxes.left) {
                this.widget.chart.options.yAxes.left = {
                    display: true,
                    label: "",
                    unit: "",
                    fontSize: 12
                };
            }
        },

        disposeChart() {
            if (this.chart) {
                this.chart.dispose();
                this.chart = null;
            }
        },

        handleResize() {
            if (this.chart) {
                // 약간의 지연을 두고 resize 실행
                this.$nextTick(() => {
                    this.chart.resize();
                });
            }
        },

        setupResizeObserver() {
            if (window.ResizeObserver && this.$refs.barChart) {
                this.resizeObserver = new ResizeObserver(() => {
                    this.handleResize();
                });
                this.resizeObserver.observe(this.$refs.barChart);
            }
        },

        // 차트 초기화 및 설정
        initChart() {
            this.disposeChart();
            this.$nextTick(() => {
                this.chart = echarts.init(this.$refs.barChart);
                this.initSetting();
                setTimeout(() => {
                    if (this.chart) {
                        this.chart.resize();
                    }
                }, 100);
            });
        },

        initSetting() {
            if (!this.chart) return;

            const series = this.defaultDatasets();
            const chartOptions = this.createChartOptions();
            chartOptions.series = series;
            chartOptions.legend = {
                ...chartOptions.legend,
                data: this.buildLegendItemsFromSeries(series),
            };
            this.chart.setOption(chartOptions);
            this.setTheme();
        },

        setTheme() {
            // this.$el.style.backgroundColor = this.themeColor.chart.bar.backgroundColor;
        },

        // 데이터 처리 메서드들
        applyData(widgetLogs) {
            this.filterdPoint.clear();
            this.widgetLogs = widgetLogs;

            const sourceLogs = this.isWeekAggregation ? this.convertWeekData(widgetLogs) : widgetLogs;
            const labels = this.isWeekAggregation ? this.createWeekLabels(sourceLogs) : this.createLabels(sourceLogs);
            const datasets = this.createDatasets(sourceLogs);

            // 원본 데이터 저장
            this.originalDatasets = JSON.parse(JSON.stringify(datasets));

            const newData = {
                data: {
                    labels,
                    datasets: this.isNormalized === "per" ? this.normalizeData(datasets) : datasets,
                },
            };

            if (this.chart) {
                this.chart.setOption({
                    xAxis: {
                        data: newData.data.labels,
                    },
                    series: newData.data.datasets,
                });
            }

            this.$nextTick(() => {
                this.updateLegend();
            });

            if (this.isNormalized === "per") {
                this.updateChartData();
            }
        },

        // 정규화 관련 메서드들
        onNormalizeToggle() {
            this.updateChartData();
        },

        normalizeData(datasets) {
            if (this.isNormalized !== "per" || !datasets || datasets.length === 0) {
                return datasets;
            }

            const dataLength = datasets[0]?.data?.length || 0;
            const rowSums = this.calculateRowSums(datasets, dataLength);

            return datasets.map((dataset) => ({
                ...dataset,
                data: dataset.data.map((value, index) => {
                    const rowSum = rowSums[index];
                    return rowSum > 0 ? (value / rowSum) * 100 : 0;
                }),
                name: `${dataset.name}`,
            }));
        },

        calculateRowSums(datasets, dataLength) {
            const rowSums = [];
            for (let i = 0; i < dataLength; i++) {
                let rowSum = 0;
                datasets.forEach((dataset) => {
                    if (dataset.data && dataset.data[i] !== undefined) {
                        rowSum += dataset.data[i] || 0;
                    }
                });
                rowSums.push(rowSum);
            }
            return rowSums;
        },

        // 차트 데이터 업데이트
        updateChartData() {
            if (!this.chart || !this.widgetLogs) return;

            const sourceLogs = this.isWeekAggregation ? this.convertWeekData(this.widgetLogs) : this.widgetLogs;
            const labels = this.isWeekAggregation ? this.createWeekLabels(sourceLogs) : this.createLabels(sourceLogs);
            const datasets = this.createDatasets(sourceLogs);

            // 원본 데이터 저장 (정규화 해제 시 사용)
            if (this.isNormalized === "abs") {
                this.originalDatasets = JSON.parse(JSON.stringify(datasets));
            }

            // 정규화된 데이터셋 생성 또는 원본 데이터 사용
            let finalDatasets;
            if (this.isNormalized === "per") {
                finalDatasets = this.normalizeData(datasets);
            } else if (this.originalDatasets.length > 0) {
                finalDatasets = this.originalDatasets;
            } else {
                finalDatasets = datasets;
            }

            const yAxisConfig = this.getYAxisConfig(finalDatasets);

            this.chart.setOption({
                xAxis: {
                    data: labels,
                },
                yAxis: {
                    ...this.chart.getOption().yAxis,
                    ...yAxisConfig,
                },
                series: finalDatasets,
                tooltip: {
                    ...this.chart.getOption().tooltip,
                    formatter: (params) => this.formatTooltip(params),
                },
            });

            this.$nextTick(() => {
                this.updateLegend();
            });
        },

        getYAxisConfig(finalDatasets) {
            const yAxisLabel =
                this.isNormalized === "per"
                    ? "비중 (%)"
                    : this.widget.chart.options.yAxes.left.label + this.widget.chart.options.yAxes.left.unit;

            let yAxisRange = {};
            if (this.isNormalized === "per") {
                yAxisRange = { min: 0, max: 100 };
            } else {
                const allValues = this.extractAllValues(finalDatasets);
                if (allValues.length > 0) {
                    const maxValue = Math.max(...allValues);
                    const minValue = Math.min(...allValues);
                    const padding = (maxValue - minValue) * 0.1;
                    yAxisRange = {
                        min: Math.max(0, minValue - padding),
                        max: maxValue + padding,
                    };
                }
            }

            return {
                name: yAxisLabel,
                ...yAxisRange,
                axisLabel: {
                    ...this.chart.getOption().yAxis.axisLabel,
                    formatter: (value) => {
                        if (this.isNormalized === "per") {
                            return `${value.toFixed(0)}%`;
                        }
                        return this.comma(value, 0);
                    },
                },
            };
        },

        extractAllValues(datasets) {
            const allValues = [];
            datasets.forEach((dataset) => {
                if (dataset.data) {
                    allValues.push(...dataset.data.filter((val) => val !== null && val !== undefined));
                }
            });
            return allValues;
        },

        formatTooltip(params) {
            if (!params || params.length === 0) return "";

            let result = `<div style="font-size: 12px; ">
                <div>
                    <p style=" font-weight: bold;">${params[0].axisValue}</p>`;

            params.forEach((param) => {
                const value =
                    this.isNormalized === "per"
                        ? `${param.value.toFixed(1)}%`
                        : this.comma(param.value, this.widget.addition.fixed) || 0;

                result += `<div style="display: flex; justify-content: space-between; margin: 4px 0;">
                    <div style="margin-right: 20px;">
                        <span style="display: inline-block; width: 10px; height: 10px; background: ${param.color}; margin-right: 5px; border-radius: 50%;"></span>
                        <span>${param.seriesName}</span>
                    </div>
                    <span style="font-weight: bold;">
                        ${value}
                    </span>
                </div>`;
            });

            result += `</div></div>`;
            return result;
        },

        // 주차 데이터 변환
        convertWeekData(widgetLogs) {
            if (this.searchBoxCond.type !== 3) return widgetLogs;

            const weekGroups = {};

            widgetLogs.forEach((log) => {
                if (!log.rows || !log.points) return;

                log.rows.forEach((row, rowIndex) => {
                    const weekKey = `week_${this.getWeek(row)}`;
                    if (!weekGroups[weekKey]) {
                        weekGroups[weekKey] = { rows: [row], points: {} };
                    } else {
                        weekGroups[weekKey].rows.push(row);
                    }

                    Object.keys(log.points).forEach((pointKey) => {
                        if (!weekGroups[weekKey].points[pointKey]) {
                            weekGroups[weekKey].points[pointKey] = [0];
                        }
                        const value = log.points[pointKey]?.[rowIndex] || 0;
                        weekGroups[weekKey].points[pointKey][0] += value;
                    });
                });
            });

            return Object.keys(weekGroups)
                .sort((a, b) => parseInt(a.split("_")[1]) - parseInt(b.split("_")[1]))
                .map((weekKey) => weekGroups[weekKey]);
        },

        getWeek(date) {
            const dateMoment = moment(date, "YYYYMMDD");
            return dateMoment.week();
        },

        // 라벨 생성 메서드들
        createWeekLabels(logs) {
            return logs.map((log, index) => `${index + 1}주차`);
        },

        createLabels(logs) {
            let labels = [];

            for (let i = 0; i < logs.length; i++) {
                let firstRows = logs[i].rows[0];

                for (let j = 0; j < logs[i].rows.length; j++) {
                    let str = logs[i].rows[j];
                    logs[i].rows[j] = this.formatDateString(str, firstRows);
                }
            }

            if (logs.length === 1) {
                labels = logs[0].rows;
            } else if (logs.length === 2) {
                let base = logs[0];
                let comp = logs[1];

                if (base.rows.length >= comp.rows.length) {
                    labels = base.rows.map((dt) => [dt]);
                } else {
                    labels = comp.rows.map((dt) => [dt]);
                }
            }
            return labels;
        },

        formatDateString(str, firstRows) {
            if (/^(\d){4}$/.test(str)) {
                return str.substr(0, 4) + global.xe.$t("년");
            } else if (/^(\d){6}$/.test(str)) {
                const m = str.substr(4, 2);
                return global.xe.$t(Number(m) + "월");
            } else if (/^(\d){8}$/.test(str)) {
                const m = str.substr(4, 2);
                const d = str.substr(6, 2);
                if (Number(firstRows.substr(4, 2)) === Number(m)) {
                    return global.xe.$t(Number(d) + "일");
                } else {
                    return str;
                }
            } else if (/^(\d){10}$/.test(str)) {
                const h = str.substr(8, 2);
                return h + global.xe.$t("시");
            } else if (/^(\d){12}$/.test(str)) {
                const h = str.substr(8, 2);
                const M = str.substr(10, 2);
                return h + ":" + M;
            }
            return str;
        },

        // 데이터셋 생성 메서드들
        defaultDatasets() {
            const validSeries = this.filterInvalidSeries(this.widget.chart.series);
            const lengthValidSeries = validSeries.length;

            return validSeries.map((item, index) => ({
                name: global.xe.$t(item.label),
                type: "bar",
                data: [],
                itemStyle: {
                    color: item.dataColor,
                    borderRadius: this.getBorderRadius(index, lengthValidSeries),
                },
                barMaxWidth: this.widget.chart.series[0].maxBarThickness,
                point: item.point,
                compare: item.compare ? item.compare : false,
            }));
        },

        getBorderRadius(index, totalLength) {
            // 스택 모드일 때는 마지막 요소에만 border-radius 적용
            if (this.isStacked) {
                return index === totalLength - 1 ? [20, 20, 0, 0] : [0, 0, 0, 0];
            }
            // 일반 모드일 때는 모든 요소에 border-radius 적용
            return [20, 20, 0, 0];
        },

        createDatasets(logs) {
            let datasets = this.defaultDatasets();

            // 주차별 데이터 특별 처리
            if (this.shouldProcessWeekData(logs)) {
                logs = this.processWeekData(logs);
            }

            // 기존 로그 복사하여 데이터 변형 작업 진행
            let copyLogs = JSON.parse(JSON.stringify(logs));
            copyLogs = utils.onAfterAction2(datasets, copyLogs, this.widget.addition.afterAction);

            // 데이터셋 생성
            datasets = datasets.map((dataset) => {
                let log = dataset.compare ? copyLogs[1] : copyLogs[0];

                if (!log || !log.points) {
                    dataset.data = [];
                    return dataset;
                }

                let ptVals = log.points[dataset.point];
                dataset.data = Array.isArray(ptVals) ? ptVals : [ptVals];

                return dataset;
            });

            return this.filterEmptyDatasets(datasets);
        },

        shouldProcessWeekData(logs) {
            return (
                this.searchBoxCond.type === 3 &&
                this.isWeekAggregation &&
                logs.length > 0 &&
                logs[0].rows &&
                logs[0].rows.length > 0
            );
        },

        processWeekData(logs) {
            const combinedLog = {
                rows: logs.map((log) => log.rows[0]),
                points: {},
            };

            const allPoints = new Set();
            logs.forEach((log) => {
                if (log.points) {
                    Object.keys(log.points).forEach((pointKey) => allPoints.add(pointKey));
                }
            });

            allPoints.forEach((pointKey) => {
                combinedLog.points[pointKey] = logs.map((log) => {
                    if (log.points && log.points[pointKey]) {
                        return log.points[pointKey][0];
                    }
                    return 0;
                });
            });

            return [combinedLog];
        },

        // 필터링 메서드들
        filterInvalidSeries(series) {
            if (!series || series.length === 0) {
                return series;
            }

            return series.filter((item) => {
                return item.point && item.point.trim() !== "" && item.label && item.label.trim() !== "";
            });
        },

        filterEmptyDatasets(datasets) {
            if (!datasets || datasets.length === 0) {
                return datasets;
            }

            return datasets.filter((dataset) => {
                if (!dataset.data || dataset.data.length === 0) {
                    return false;
                }

                const hasTruthyValue = dataset.data.some((value) => {
                    if (value !== null && value !== undefined && value !== "" && value !== 0) {
                        this.filterdPoint.add(dataset.point);
                        return true;
                    }
                    return false;
                });

                return hasTruthyValue;
            });
        },

        // Legend 관련 메서드들 — ECharts는 legend.data의 name이 실제 series.name과 일치해야 함
        buildLegendItemsFromSeries(seriesList) {
            if (!seriesList || seriesList.length === 0) {
                return [];
            }
            return seriesList
                .filter((s) => s && s.name != null && String(s.name) !== "")
                .map((s) => ({
                    name: s.name,
                    icon: "circle",
                    textStyle: {
                        fontSize: 12,
                    },
                }));
        },

        updateLegend() {
            if (!this.chart) return;

            const opt = this.chart.getOption();
            const raw = opt.series;
            const seriesList = Array.isArray(raw) ? raw : raw ? [raw] : [];
            const legendData = this.buildLegendItemsFromSeries(seriesList);
            this.chart.setOption({
                legend: {
                    data: legendData,
                },
            });
        },

        // 차트 옵션 생성
        createChartOptions() {
            const compact = this.isOverviewCompact;
            const axisFont = compact ? 8 : this.widget.chart.chartFontSize;
            const leftAxis = this.widget.chart.options.yAxes.left;
            return {
                stack: this.isStacked ? "total" : undefined,
                // backgroundColor: this.themeColor.chart.bar.backgroundColor,
                grid: {
                    top: compact ? "24%" : "30%",
                    left: compact ? "2%" : "5%",
                    right: compact ? "3%" : "5%",
                    height: compact ? "68%" : "65%",
                    containLabel: true,
                },
                tooltip: {
                    show: true,
                    appendToBody: true,
                    trigger: "axis",
                    confine: false,
                    axisPointer: {
                        type: "shadow",
                    },
                    backgroundColor: "rgba(0,0,0,0.9)",
                    borderColor: "rgba(0,0,0,0.9)",
                    textStyle: {
                        color: "#fff",
                        fontSize: compact ? "10px" : "12px",
                    },
                    formatter: (params) => this.formatTooltip(params),
                },
                legend: {
                    show: this.widget.chart.options.legend.display,
                    top: compact ? 2 : undefined,
                    left: compact ? "center" : undefined,
                    itemGap: compact ? 8 : 12,
                    itemWidth: compact ? 8 : 12,
                    itemHeight: compact ? 8 : 12,
                    textStyle: {
                        color: this.themeColor.chart.bar.fontColor,
                        fontSize: compact ? 9 : this.widget.chart.options.legend.labels.fontSize,
                    },
                },
                xAxis: {
                    type: "category",

                    axisLabel: {
                        color: this.themeColor.chart.bar.fontColor,
                        fontSize: axisFont,
                    },
                    axisLine: {
                        lineStyle: {
                            color: this.themeColor.chart.bar.gridLineColor,
                        },
                    },
                },
                yAxis: {
                    type: "value",
                    // compact: kWh 등 name이 legend와 겹치지 않게 숨김
                    name: compact ? "" : leftAxis.label + leftAxis.unit,
                    nameGap: compact ? 8 : undefined,
                    axisLabel: {
                        color: this.themeColor.chart.bar.fontColor,
                        fontSize: axisFont,
                        formatter: (value) => this.comma(value, 0),
                    },
                    axisLine: {
                        lineStyle: {
                            color: this.themeColor.chart.bar.gridLineColor,
                        },
                    },
                    splitLine: {
                        lineStyle: {
                            color: this.themeColor.chart.bar.gridLineColor,
                        },
                    },
                    nameTextStyle: {
                        color: this.themeColor.chart.bar.fontColor,
                        fontSize: compact ? 8 : leftAxis.fontSize,
                    },
                },
                series: [],
            };
        },
    },
};
</script>

<style scoped>
.xeBar {
    height: 100%;
}

.barChart {
    width: 100%;
    height: 100%;
}

.chartHeightMax {
    height: calc(100% - 41px);
    width: 100%;
}

.chartHeightMax .p-5 {
    padding: 0 !important;
}

.safari-style-buttons {
    display: flex;
    gap: 8px;
    align-items: center;
}

.safari-button {
    position: relative;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
    border: 1px solid rgba(0, 0, 0, 0.1);
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}

.safari-button:hover {
    transform: scale(1.1);
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
}

.safari-button input[type="radio"] {
    position: absolute;
    opacity: 0;
    width: 100%;
    height: 100%;
    cursor: pointer;
}

.safari-button.red {
    background: linear-gradient(135deg, #ff5f57 0%, #ff4444 100%);
}

.safari-button.yellow {
    background: linear-gradient(135deg, #ffbd2e 0%, #ffb300 100%);
}

.safari-button.green {
    background: linear-gradient(135deg, #28ca42 0%, #4caf50 100%);
}

.safari-button input[type="radio"]:checked+.button-dot {
    opacity: 1;
}

.button-dot {
    width: 4px;
    height: 4px;
    background-color: rgba(0, 0, 0, 0.6);
    border-radius: 50%;
    opacity: 0;
    transition: opacity 0.2s ease;
}

.safari-button input[type="radio"]:checked {
    box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.3);
}

.safari-button input[type="radio"]:checked+.button-dot {
    opacity: 1;
}
</style>
